import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";

const initial_value = {
  name: "",
  service_type: 1,
  quantity_type: 1,
  quantity: 1,
  price: "",
  roles: { roles: [], custom_roles: [] },
  gst: "",
  hsn: "",
};

const animatedComponents = makeAnimated();

let myModal = {};

export default function ModalAddTask(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [save_data, SetSaveData] = useState(initial_value);
  const [id_value, SerIdValue] = useState(useParams());
  const [task_list, SetTaskList] = useState([
    {
      name: "",
      price: "",
      skills: [],
    },
  ]);

  useEffect(() => {
    console.log("ModalAddTask On mount :", props);
    let myModal1 = document.getElementById("AddTaskModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      SetTaskList([
        {
          name: "",
          price: "",
          skills: [],
        },
      ]);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("On Open modal :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("AddTaskModal"),
        {}
      );
      myModal.show();
      console.log("myModal show:", myModal);
    }
  }, [props.open]);

  async function save() {
    console.log("save :", task_list);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        service_id: id_value.service_id,
        task: task_list,
      },
    };
    let data = await api("/outlet/add_service_task", pass_data);
    console.log("add_service_task :", data.response);
    if (data.response.hasOwnProperty("services")) {
      SetCloseData((prevValue) => {
        prevValue.action = "save";
        prevValue.services = data.response.services[0];
        return { ...prevValue };
      });
      myModal.hide();
    }
  }

  function get_selected_skills(value_skills: any) {
    let selected_value = [];
    value_skills.map((ele) => {
      props.skill_data.map((skill_ele) => {
        let index_value = skill_ele.options.findIndex(
          (op_ele) => op_ele.value == ele
        );
        if (index_value != -1) {
          selected_value.push(skill_ele.options[index_value]);
        }
      });
    });
    return selected_value;
  }

  return (
    <div
      className="modal fade"
      id="AddTaskModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              Add Task
            </h5>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body scroll-height">
            <div className="d-flex ">
              <div className="ms-auto btn-light-outline d-flex align-items-center text-dark cursor py-1 px-2"
                onClick={() => {
                  let task_value = {
                    name: "",
                    price: "",
                    skills: [],
                  };
                  SetTaskList((prevValue) => {
                    prevValue.push(task_value);
                    return [...prevValue];
                  });
                }}
              >
                <img src={require("../../../assets/icon/svg/plus1.svg")} className="action_img pe-1" />
                Add new
              </div>
            </div>

            {task_list.map((ele, index) => (
              <fieldset className="border px-3 pb-3 mt-4" key={index} >
                <legend className="text-center">
                  <div
                    className="cursor ms-auto text-red d-flex"
                    onClick={() => {
                      SetTaskList((prevValue) => {
                        prevValue.splice(index, 1);
                        console.log("Sliced Data :", prevValue);
                        return [...prevValue];
                      });
                    }}
                  >
                    <img src={require("../../../assets/icon/svg/x2.svg")} className="pe-2" />
                    Remove
                  </div>
                </legend>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ele.name}
                      required
                      onChange={(e) => {
                        SetTaskList((prevValue) => {
                          prevValue[index].name = e.target.value;
                          return [...prevValue];
                        });
                      }}
                    />
                  </div>

                  <div className=" col-md-4">
                    <label className="form-label">Price</label>
                    <input
                      type="number"
                      className="form-control"
                      value={ele.price}
                      required
                      onChange={(e) => {
                        SetTaskList((prevValue) => {
                          prevValue[index].price = e.target.value;
                          return [...prevValue];
                        });
                      }}
                    />
                  </div>
                  {/* 
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            SetTaskList((prevValue) => {
                              prevValue.splice(index, 1);
                              console.log("Sliced Data :", prevValue);
                              return [...prevValue];
                            });
                          }}
                        >
                          Remove
                        </button>
                      </div> */}

                  <div className="col-12 mt-2">
                    <label className="form-label">Skills</label>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      isMulti
                      value={get_selected_skills(ele.skills)}
                      options={props.skill_data}
                      onChange={(e) => {
                        console.log("e :", e);
                        let skill_value = [];
                        e.map((ele) => {
                          skill_value.push(ele.value);
                        });
                        SetTaskList((prevValue) => {
                          prevValue[index].skills = skill_value;
                          return [...prevValue];
                        });
                      }}
                    />
                  </div>
                </div>
              </fieldset>

            ))}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={save}
            // data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
